import React, { Component } from "react";
import { connect } from "react-redux";
import { notificationAction } from "../../../actions";
import NewOpportunity from "./common/NewOpportunity";

class NewOpportunityAcceptedIpro extends Component {
  render() {
    const {
      userId,
      labels,
      IsSearcher,
      notificationAction,
      location,
      isHelpActive,
    } = this.props;
    const {
      Invitation_Empty,
      iproOpportunityAcceptedSearchField,
      TooltipIproOpportunityNewListCollapse,
      HlpTooltipIproOpportunityNewListCollapse,
      ViewTitleInvitationList,
      iproOpportunityNewDetailsHeading,
      ToolTipInvitationExpandDetail,
      HlpTooltipIproOpportunityNewDetailExpand,
      ToolTipInvitationCollaspeDetail,
      HlpTooltipIproOpportunityNewDetailCollapse,
      ViewTitleInvitationDetail,
      iproOpportunityNewCompanyDetailHeading,
      ToolTipCompanyExpandDetail,
      HlpTooltipIproOpportunityNewUserDetailExpand,
      ToolTipCompanyCollaspeDetail,
      HlpTooltipIproOpportunityNewUserDetailCollapse,
      ViewTitleCompanyDetail,
      ToolTipInvitationExpandList,
      HlpTooltipIproOpportunityNewListExpand,
      iProOpportunityNewDetailLblHeading,
      iProOpportunityNewDetailLblLocation,
      iProOpportunityNewDetailLblStartDate,
      iProOpportunityNewDetailLblDuration,
      iProOpportunityNewDetailLblCompany,
      iProOpportunityNewDetailLblDescription,
      iProOpportunityNewDetailLblSearchParameterHeading,
      iProOpportunityNewDetailLblProfile,
      iProOpportunityNewDetailLblSkills,
      iProOpportunityNewDetailLblKeyword,
      iProOpportunityNewDetailLblIndustry,
      iProOpportunityNewDetailLblCertification,
      iProOpportunityNewDetailLblCountry,
      iProOpportunityNewDetailLblInterest,
      iProOpportunityNewDetailBtnAccept,
      iProOpportunityNewDetailBtnDecline,
      iProOpportunityNewDetailLblLanguage,
      iProOpportunityNewDetailLblTitle,
      IproOpportunityNewCompanyAddressLabel,
      IproOpportunityNewCompanyIndustryLabel,
      IproOpportunityNewCompanyCountryLabel,
      IproOpportunityNewCompanyPhoneLabel,
      IproOpportunityNewCompanyWebUrlLabel,
      IproOpportunityNewCompanyVatLabel,
      iproInvitationSuccessfullyDeleted,
    } = labels;
    return (
      <NewOpportunity
        url={`?type=4`}
        isAccepted={true}
        isAcceptedView
        opportunityType="AcceptedRequests"
        IsSearcher={false}
        isHelpActive={isHelpActive}
        notificationAction={notificationAction}
        Lbltitle={iProOpportunityNewDetailLblTitle}
        locationsLabel={iProOpportunityNewDetailLblLocation}
        startDateLabel={iProOpportunityNewDetailLblStartDate}
        durationLabel={iProOpportunityNewDetailLblDuration}
        companyLabel={iProOpportunityNewDetailLblCompany}
        descriptionLabel={iProOpportunityNewDetailLblDescription}
        countryLabel={iProOpportunityNewDetailLblCountry}
        SearchParameterHeading={
          iProOpportunityNewDetailLblSearchParameterHeading
        }
        LblProfile={iProOpportunityNewDetailLblProfile}
        LblSkills={iProOpportunityNewDetailLblSkills}
        LblKeyword={iProOpportunityNewDetailLblKeyword}
        LblIndustry={iProOpportunityNewDetailLblIndustry}
        LblCertification={iProOpportunityNewDetailLblCertification}
        LblCountry={iProOpportunityNewDetailLblCountry}
        LblLanguage={iProOpportunityNewDetailLblLanguage}
        LblInterest={iProOpportunityNewDetailLblInterest}
        BtnAccept={iProOpportunityNewDetailBtnAccept}
        BtnDecline={iProOpportunityNewDetailBtnDecline}
        companyAddressLabel={IproOpportunityNewCompanyAddressLabel}
        companyIndustryLabel={IproOpportunityNewCompanyIndustryLabel}
        companyCountryLabel={IproOpportunityNewCompanyCountryLabel}
        companyPhoneLabel={IproOpportunityNewCompanyPhoneLabel}
        companyWebUrlLabel={IproOpportunityNewCompanyWebUrlLabel}
        companyVatLabel={IproOpportunityNewCompanyVatLabel}
        searchInputPlaceholder={iproOpportunityAcceptedSearchField}
        toolTipExpandList={ToolTipInvitationExpandList}
        helpTooltipExpandList={HlpTooltipIproOpportunityNewListExpand}
        toolTipCollapseList={TooltipIproOpportunityNewListCollapse}
        helpTooltipCollapseList={HlpTooltipIproOpportunityNewListCollapse}
        listColumnText={ViewTitleInvitationList}
        // detail section system label
        detailHeadingText={iproOpportunityNewDetailsHeading}
        toolTipExpandDetail={ToolTipInvitationExpandDetail}
        helpTooltipExpandDetail={HlpTooltipIproOpportunityNewDetailExpand}
        toolTipCollapseDetail={ToolTipInvitationCollaspeDetail}
        helpTooltipCollapseDetail={HlpTooltipIproOpportunityNewDetailCollapse}
        detailsColumnText={ViewTitleInvitationDetail}
        // selected user detail and company section system label
        userDetailHeadingText={iproOpportunityNewCompanyDetailHeading}
        toolTipExpandUserDetail={ToolTipCompanyExpandDetail}
        helpTooltipExpandUserDetail={
          HlpTooltipIproOpportunityNewUserDetailExpand
        }
        toolTipCollapseUserDetail={ToolTipCompanyCollaspeDetail}
        helpTooltipCollapseUserDetail={
          HlpTooltipIproOpportunityNewUserDetailCollapse
        }
        userDetailsColumnText={ViewTitleCompanyDetail}
        emptyOpportunityInfo={labels?.emptyOpportunityInfo}
        listCollapsedTestId={"listCollapsedTestId1"}
        listCollapsedHelpTestId={"listCollapsedTestId2"}
        listExpandTestId={"listCollapsedTestId3"}
        listExpandHelpTestId={"listCollapsedTestId4"}
        detailCollapsedTestId={"listCollapsedTestId5"}
        detailCollapsedHelpTestId={"listCollapsedTestId6"}
        detailExpandTestId={"listCollapsedTestId7"}
        detailExpandHelpTestId={"listCollapsedTestId8"}
        userDetailCollapsedTestId={"listCollapsedTestId9"}
        userDetailCollapsedHelpTestId={"listCollapsedTestId10"}
        userDetailExpandTestId={"listCollapsedTestId11"}
        userDetailExpandHelpTestId={"listCollapsedTestId12"}
        searchInputTestId="opportunity-accept-search-input"
        iproOpportunityListItem="iproOpportunityListItem-accept"
        iproInvitationSuccessfullyDeleted={iproInvitationSuccessfullyDeleted}
        locationProp={location}
      />
    );
  }
}

const mapStateToProps = ({ systemLabel, userInfo, navigation }) => {
  const { labels } = systemLabel;
  const { user } = userInfo;
  const { isHelpActive } = navigation;
  let { UserId, IsFreelancer } = user;
  UserId =
    UserId !== undefined ? UserId : parseInt(sessionStorage.getItem("userId"));
  IsFreelancer =
    IsFreelancer !== undefined
      ? IsFreelancer
      : JSON.parse(localStorage.getItem("IsFreelancer"));
  return {
    labels,
    userId: UserId,
    IsSearcher: !IsFreelancer,
    IsFreelancer,
    isHelpActive,
  };
};

const actions = { notificationAction };
export default connect(mapStateToProps, actions)(NewOpportunityAcceptedIpro);
